export default (links, linksdropdown) => {
    
    return `
    
        <div class="row justify-content-center">
            <div class="d-none d-lg-block col-xl-8 col-xxl-12">
        
                <div class="timeline__pages text-center" id="timelinemenu">
                    ${links}
                </div>
                
            </div>
            <div class="d-lg-none col-12">
                <div class="text-center">
                    <div class="tl-dropdown__container">
                        <button class="tl-dropdown__choise text-left" id="tl-dropdown__button">
                            <span id="dropdownchoise"></span><span class="material-icons-outlined tl-dropdown__iconmore">expand_more</span>
                        </button>
                        <div class="tl-dropdown__modal text-left d-none" id="tl-dropdown__list">
                            ${linksdropdown}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    `;
    
}

export const timelinelinks = (category, first, classprefix) => {
    
    return `<a href="#${urlify(category.item)}" data-categoryid="${category.categoryId}" class=" ${classprefix}${first} ${classprefix}">${category.previewItem}</a>`
    
}